import asyncPoll from 'lib/promise/asyncPoll'
import { getOrderById } from '../../api/order'

interface PollDowngradeStatusParams {
  orderId: string
  requiredStatus: Array<string>
  maxTime: number
}

/** Polls for order until rebooking process is finished
 * checks so order has no items with status created
 * used in all flows that perform rebooking: change_package, extend_dates, LPC/LPP change_dates
 */
const pollDowngradeStatus = async({ orderId, requiredStatus, maxTime }: PollDowngradeStatusParams) => {
  return await asyncPoll({
    validateFunction: async(result: App.Order) => {
      const items = [...result.items, ...result.bedbankItems]

      return !items.find((item) => requiredStatus.includes(item.status))
    },
    apiCall: () => getOrderById(orderId),
    maxTime,
    pollInterval: 1000,
  })
}

export default pollDowngradeStatus
